export default __webpack_public_path__ + "static/media/mastercardlogo.2e35bd39.svg";